/* global IMask */

/**
 * Applies a Brazilian phone number input mask to every element with the `.tel-mask` class.
 * @returns {void}
 */
function initTelMask() {
    document.querySelectorAll('.tel-mask').forEach(e => {
        new IMask(e, {
            mask: [
                { mask: '(00) 0000-0000' },
                { mask: '(00) 0 0000-0000' }
            ]
        });
    });
}

initTelMask();
